export default "__VITE_ASSET__eb98db41__"